import { Golem } from "./golem";
export class PurpleGolem extends Golem {
    constructor() {
        super(...arguments);
        this.cooldown = 4000;
    }
}
PurpleGolem.displayName = "Purple Golem";
PurpleGolem.artUrl = "./assets/cards/purplegolem.jpg";
PurpleGolem.effect = {
    callback: () => { },
    description: "Consume a Rock and play a card every 4 seconds",
    needsFeedback: true,
};
